module.exports = __webpack_public_path__ + "media/images/allcare-academy-bg-ebf667d6f962b8dda86271dbe22424ad.png";